import { useState } from "react";
import { Modal } from "./ui/Modal";
import { Button } from "./ui/Button";
import { useStore } from "../state/store";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function LoginDialog({ open, onClose }: Props) {
  const login = useStore((s) => s.loginAdmin);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      await login(username, password);
      setUsername("");
      setPassword("");
      onClose();
    } catch (err) {
      setError(
        err instanceof Error && err.message === "invalid_credentials"
          ? "Onjuiste combinatie van gebruikersnaam en wachtwoord."
          : "Inloggen mislukt. Controleer de verbinding.",
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Admin inloggen" width="22rem">
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label className="block text-xs font-medium mb-1">Gebruikersnaam</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
            className="w-full bg-background border border-input rounded-md px-2 py-1.5 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium mb-1">Wachtwoord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="w-full bg-background border border-input rounded-md px-2 py-1.5 text-sm"
          />
        </div>
        {error && <div className="text-xs text-destructive">{error}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="outline" size="sm" onClick={onClose}>
            Annuleer
          </Button>
          <Button type="submit" size="sm" disabled={pending || !username || !password}>
            {pending ? "Bezig…" : "Inloggen"}
          </Button>
        </div>
        <p className="text-[11px] text-muted-foreground pt-1">
          Alleen voor beheerders. Gebruikers kunnen scenario's bekijken zonder login.
        </p>
      </form>
    </Modal>
  );
}
